module.exports = __webpack_public_path__ + "static/media/verdeSweetheart.a62f139e.jpg";